import { PAGINATION_SIZES } from '@optimus-web/core';

export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = PAGINATION_SIZES[50];

export const FORM_NAME = 'payouts-filters';
